export default "__VITE_ASSET__au33fjhx__"